module.exports = __webpack_public_path__ + "media/icons/share-5386afe8.svg";